import React, { useEffect, useState, useMemo } from 'react';
import 'moment/locale/it';

import { useAuth0 } from '../../context/auth0';
import Typography, { TypographyVariants, TypographyWeights } from '../../ui-components/Typography/Typography';
import Button, { ButtonSizes, ButtonStyles, ButtonWidths } from '../Button/Button';
import { TRANSLATIONS } from '../../../translations';

const LoginSection = () => {

  const { loginWithRedirect } = useAuth0();

  return (
    <div className="cell">
      <div className='d-flex flex-column gap-2xl pb-3xl'>
        <div className='d-flex justify-center'>
          <Typography
            classNames={'text-center'}
            variant={TypographyVariants.p2}
            weight={TypographyWeights.bold}>
            {TRANSLATIONS.LOG_IN_TO_MANAGE_YOUR_RESERVATIONS}
          </Typography>
        </div>
        <div className='w-100% d-flex flex-wrap justify-center gap-m'>
          <div style={{ width: '140px' }}>
            <Button
              width={ButtonWidths.isFull}
              size={ButtonSizes.s}
              style={ButtonStyles.secondary}
              label={<Typography variant={TypographyVariants.p3} weight={TypographyWeights.bold}>
                {app_main_wpml.login}
              </Typography>
              }
              onClick={loginWithRedirect}
            />
          </div>
          <div style={{ width: '140px' }}>
            <Button
              width={ButtonWidths.isFull}
              size={ButtonSizes.s}
              style={ButtonStyles.empty}
              label={<Typography variant={TypographyVariants.p3} weight={TypographyWeights.bold}>
                {app_main_wpml.back_to_home}
              </Typography>
              }
              redirect={'/'}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

LoginSection.propTypes = {};

export default LoginSection;
